<template>
  <fragment>
    <AppBody
      title="Relatórios Analíticos"
      subtitle="Venda Detalhada por Ingresso"
      :actions="actions"
      :primaryLoading="exportCSVLoading"
      :secondaryLoading="exportPDFLoading"
      disableDivider
    >
      <CardModule untitle>
        <v-row>
          <v-col class="custom-chip-group">
            <v-chip-group
              show-arrows
              v-model="tab"
              active-class="primary--text"
              mandatory
            >
              <v-chip outlined v-for="(item, index) in tabInfo" :key="index">
                {{ item.title }}
              </v-chip>
            </v-chip-group>
          </v-col>
        </v-row>

        <v-tabs-items v-model="tab">
          <v-tab-item v-for="(item, index) in tabInfo" :key="index">
            <component :is="item.component"></component>
          </v-tab-item>
        </v-tabs-items>
      </CardModule>
    </AppBody>
  </fragment>
</template>
<script>
import CardModule from "@/components/cards/CardModule.vue";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseAutocomplete from "@/components/forms/BaseAutocomplete.vue";
import BaseButton from "@/components/forms/BaseButton.vue";
import AppBody from "@/layouts/components/AppBody.vue";

import General from "@/components/relatorios/General.vue";
import SalesByTicket from "@/components/relatorios/SalesByTicket.vue";
import SalesByDay from "@/components/relatorios/SalesByDay.vue";
import SalesByEvent from "@/components/relatorios/SalesByEvent.vue";
import SalesByChannel from "@/components/relatorios/SalesByChannel.vue";
import SalesByPaymentMethod from "@/components/relatorios/SalesByPaymentMethod.vue";
import PackageEmission from "@/components/relatorios/PackageEmission.vue";
import Receivables from "@/components/relatorios/Receivables.vue";
import Financial from "@/components/relatorios/Financial.vue";
import SalesByPointOfSale from "@/components/relatorios/SalesByPointOfSale.vue";
import DiscountCoupon from "@/components/relatorios/DiscountCoupon.vue";
import Cancellation from "@/components/relatorios/Cancellation.vue";

import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: "GeneralAnalytical",
  metaInfo: {
    title:
      "Relatório Analítico de Venda Detalhada por Ingresso | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content:
          "Relatório Analítico de Venda Detalhada por Ingresso | ElevenTickets",
      },
    ],
  },
  props: {},
  components: {
    CardModule,
    BaseSelect,
    BaseTextField,
    BaseAutocomplete,
    BaseButton,
    AppBody,
    General,
    SalesByTicket,
    SalesByDay,
    SalesByEvent,
    SalesByChannel,
    SalesByPaymentMethod,
    PackageEmission,
    Receivables,
    Financial,
    SalesByPointOfSale,
    DiscountCoupon,
    Cancellation,
  },
  data() {
    return {
      filter: {
        dateInterval: "",
        rangeDates: [],
      },
      actions: [
        {
          id: "CSV",
          name: "",
          icon: "mdi-microsoft-excel",
          action: () => this.exportCSV(),
        },
        {
          id: "PDF",
          name: "",
          icon: "mdi-file-pdf-box",
          action: () => this.exportPDF(),
        },
      ],
      tab: 0,
      tabInfo: [
        {
          title: "Geral",
          component: General,
        },
        {
          title: "Por tipo de produto",
          component: SalesByTicket,
        },
        {
          title: "Por dia",
          component: SalesByDay,
        },
        {
          title: "Por evento",
          component: SalesByEvent,
        },
        {
          title: "Por canal de vendas",
          component: SalesByChannel,
        },
        {
          title: "Por forma de pagamento",
          component: SalesByPaymentMethod,
        },
        {
          title: "Por emissão de pacotes",
          component: PackageEmission,
        },
        {
          title: "Por recebíveis",
          component: Receivables,
        },
        {
          title: "Financeiro",
          component: Financial,
        },
        {
          title: "Por ponto de venda",
          component: SalesByPointOfSale,
        },
        {
          title: "Por cupom de desconto",
          component: DiscountCoupon,
        },
        {
          title: "Por cancelamento",
          component: Cancellation,
        },
      ],
    };
  },
  methods: {
    ...mapActions([
      "exportDetailedSalesByEventPDF",
      "exportDetailedSalesByEventCSV",
      "exportSalesByTicketPDF",
      "exportSalesByTicketCSV",
      "exportSalesByDayPDF",
      "exportSalesByDayCSV",
      "exportSalesByEventPDF",
      "exportSalesByEventCSV",
      "exportSalesByChannelPDF",
      "exportSalesByChannelCSV",
      "exportSalesByPointOfSalePDF",
      "exportSalesByPointOfSaleCSV",
      "exportPaymentMethodPDF",
      "exportPaymentMethodCSV",
      "exportSendingPackagesPDF",
      "exportSendingPackagesCSV",
      "exportFinancialReportPDF",
      "exportFinancialReportCSV",
      "exportDiscountCouponPDF",
      "exportDiscountCouponCSV",
      "exportCancellationPDF",
      "exportCancellationCSV",
    ]),
    ...mapMutations(["setReportsFilter"]),
    exportPDF() {
      switch (this.tab) {
        case 0:
          this.exportDetailedSalesByEventPDF(this.reportsFilter);
          break;
        case 1:
          this.exportSalesByTicketPDF(this.reportsFilter);
          break;
        case 2: {
          this.exportSalesByDayPDF(this.reportsFilter);
          break;
        }
        case 3:
          this.exportSalesByEventPDF(this.reportsFilter);
          break;
        case 4:
          this.exportSalesByChannelPDF(this.reportsFilter);
          break;
        case 5:
          this.exportPaymentMethodPDF(this.reportsFilter);
          break;
        case 6:
          this.exportSendingPackagesPDF(this.reportsFilter);
          break;
        case 7:
          this.$relatorios_sinteticos.imprimirPDF("recebimentos");
          break;
        case 8:
          this.exportFinancialReportPDF(this.reportsFilter);
          break;
        case 9:
          this.exportSalesByPointOfSalePDF(this.reportsFilter);
          break;
        case 10:
          this.exportDiscountCouponPDF(this.reportsFilter);
          break;
        case 11:
          this.exportCancellationPDF(this.reportsFilter);
          break;
      }
    },
    exportCSV() {
      switch (this.tab) {
        case 0:
          this.exportDetailedSalesByEventCSV(this.reportsFilter);
          break;
        case 1:
          this.exportSalesByTicketCSV(this.reportsFilter);
          break;
        case 2: {
          this.exportSalesByDayCSV(this.reportsFilter);
          break;
        }
        case 3:
          this.exportSalesByEventCSV(this.reportsFilter);
          break;
        case 4:
          this.exportSalesByChannelCSV(this.reportsFilter);
          break;
        case 5:
          this.exportPaymentMethodCSV(this.reportsFilter);
          break;
        case 6:
          this.exportSendingPackagesCSV(this.reportsFilter);
          break;
        case 7:
          this.$relatorios_sinteticos.imprimirCSV("recebimentos");
          break;
        case 8:
          this.exportFinancialReportCSV(this.reportsFilter);
          break;
        case 9:
          this.exportSalesByPointOfSaleCSV(this.reportsFilter);
          break;
        case 10:
          this.exportDiscountCouponCSV(this.reportsFilter);
          break;
        case 11:
          this.exportCancellationCSV(this.reportsFilter);
          break;
      }
    },
  },
  computed: {
    ...mapGetters([
      "storeSequencial",
      "exportCSVLoading",
      "exportPDFLoading",
      "reportsFilter",
    ]),
  },
  mounted() {
    this.setReportsFilter({ producerId: this.storeSequencial });
  },
};
</script>
<style scoped>
.custom-chip-group {
  display: flex;
  justify-content: center;
}
</style>
